import React, { useState, useEffect } from 'react';
import './ScrollToTop.css';

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      // Check for Landing page custom scroll container
      const contentScroller = document.querySelector('.content-scroller');
      
      const scrollTop = contentScroller ? contentScroller.scrollTop : window.scrollY;
      
      if (scrollTop > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    // Listen to both window scroll and content-scroller scroll
    const contentScroller = document.querySelector('.content-scroller');
    
    if (contentScroller) {
      contentScroller.addEventListener('scroll', toggleVisibility);
    }
    window.addEventListener('scroll', toggleVisibility);
    
    return () => {
      if (contentScroller) {
        contentScroller.removeEventListener('scroll', toggleVisibility);
      }
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    // Check for Landing page custom scroll container
    const contentScroller = document.querySelector('.content-scroller');
    
    if (contentScroller) {
      // For Landing page, check if we're on the hero or in content
      const landingRoot = document.querySelector('.landing-root');
      if (landingRoot) {
        // If we're in content area, go back to hero
        if (typeof window.enterContent === 'function') {
          // We're in content mode, go back to hero
          const landingRootElement = document.querySelector('.landing-root');
          if (landingRootElement && !landingRootElement.classList.contains('on-hero')) {
            // Trigger hero mode
            window.enterContent = () => {
              // This will be handled by the Landing component's state
            };
            // Force scroll to top and trigger hero state
            contentScroller.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
            // Dispatch a custom event to notify Landing component
            window.dispatchEvent(new CustomEvent('scrollToHero'));
          } else {
            // Already in hero, just scroll to top
            contentScroller.scrollTo({
              top: 0,
              behavior: 'smooth'
            });
          }
        } else {
          // Normal scroll to top for content-scroller
          contentScroller.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      } else {
        // Not on landing page, normal scroll
        contentScroller.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    } else {
      // For other pages, scroll the window
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <button
      className={`scroll-to-top ${isVisible ? 'visible' : ''}`}
      onClick={scrollToTop}
      aria-label="Scroll to top"
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 4L12 20M12 4L6 10M12 4L18 10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  );
};

export default ScrollToTop;
